const zh = {
	messageRecord: '消息通知记录',
	myProject: '我的项目',
	goProjectTip: '您需要跳转到此项目，才能进行查看消息！',
	tips: '提示',
	jump: '跳转',
};
export default zh;
